import { inject, Injectable } from '@angular/core';
import { WalletStatus, WalletStore } from '@features/wallet/application/store/wallet.store';

@Injectable({ providedIn: 'root' })
export class ActivateWalletUseCase {
    private readonly store = inject(WalletStore);

    execute(): void {
        this.store.setStatus(WalletStatus.ACTIVE);
    }
}
